import { AxiosResponse } from "axios";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest
} from "services/client/request";
import { Business, DashboardSummary } from "types/Dashboard";
import { Promotion } from "types/Promotion";

const apiVersion = "/api/v1";

export const getDashboardSummary = async (
  accessToken: string,
  businessId: string
): Promise<DashboardSummary> => {
  const response: AxiosResponse<DashboardSummary> = await getRequest(
    `${apiVersion}/business/dashboard/${businessId}`,
    accessToken
  );

  const dashboard: DashboardSummary = response.data
    ? response.data
    : ({} as DashboardSummary);

  return dashboard;
};

export const createPromotionApi = async (
  accessToken: string,
  businessId: string,
  title: string,
  body: string
): Promise<void> => {
  const response: AxiosResponse = await postRequest(
    `${apiVersion}/business/${businessId}/promotion`,
    accessToken,
    {
      title: title,
      body: body
    }
  );
  return response.data.success;
};

export const editPromotionApi = async (
  accessToken: string,
  businessId: string,
  promotionId: string,
  title: string,
  body: string
): Promise<void> => {
  const response: AxiosResponse = await patchRequest(
    `${apiVersion}/business/${businessId}/promotion/${promotionId}`,
    accessToken,
    {
      title: title,
      body: body
    }
  );
  return response.data.success;
};

export const getPromotionApi = async (
  accessToken: string,
  businessId: string
): Promise<Promotion[]> => {
  const response: AxiosResponse<Promotion[]> = await getRequest(
    `${apiVersion}/business/${businessId}/promotions`,
    accessToken
  );

  return response.data;
};

export const getOwnerAllBusinessApi = async (
  accessToken: string
): Promise<Business[]> => {
  const response: AxiosResponse<any> = await getRequest(
    `${apiVersion}/business/all`,
    accessToken
  );

  return response.data.businesses;
};

export const deletePromotionApi = async (
  accessToken: string,
  businessId: string,
  promotionId: string
): Promise<void> => {
  await deleteRequest(
    `${apiVersion}/business/${businessId}/promotion/${promotionId}`,
    accessToken
  );
};

export const setPaymentStatusApi = async (
  accessToken: string,
  businessId: string
): Promise<string> => {
  try {
    const data = {
      success_url: window.location.origin + "/payment/success",
      cancel_url: window.location.origin + "/payment/cancel",
      business_id: businessId
    };
    const response: AxiosResponse = await postRequest(
      `${apiVersion}/stripe-subscription`,
      accessToken,
      data
    );
    console.log("Payment setup response:", response.data);
    return response.data.session;
  } catch (error) {
    console.error("Error setting payment status:", error);
    throw error; // Re-throw the error for further handling
  }
};
